import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIFetchRequestOptions, IAPIFetchResponse } from '@sondermind/utilities/models-http';

@Injectable({
  providedIn: 'root',
})
export class BenefitVerificationsHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) { }

  costEstimateShown$(
    id: number,
    accountSetupType: string,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<string> {
    const params = this.http.generateListParams(opts);

    return this.http.patch<IAPIFetchResponse<string>>(
      this.fetchUrl(id),
      { cost_estimate_account_setup_type: accountSetupType },
      params
    ).pipe(
      map((resp) => resp.data),
      this.http.handleHttpError(opts.error)
    );
  }

  fetchUrl(id: number | string): string {
    return `${this.configurationService.env.svcBase}/billing/benefit_verifications/${id}/mark_cost_estimate_shown`;
  }
}
